/*! Trekano Upfit OS(TM) — proprietary. Copyright (c) Trekano. All rights reserved.
 *  "Trekano" and "Trekano Upfit OS" are trademarks of Trekano. Unauthorised
 *  copying, scraping or reverse-engineering of this code is prohibited and may
 *  result in legal action. Access grants no licence.  Enquiries: info@trekano.com */
/* TREKANO — Factory Options + Vehicle Information: parent/child tabs (desktop), accordions (mobile).
   External file so a storefront app can't inject into an inline <script>. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('.trk-tabs[data-trk-tabs]');
  if (!roots.length) return;

  var descriptions = {};
  try {
    var el = document.getElementById('trk-factory-desc');
    if (el) descriptions = JSON.parse(el.textContent);
  } catch (e) { /* graceful */ }

  roots.forEach(function (root) {
    if (root.dataset.trkInit === '1') return;
    root.dataset.trkInit = '1';

    // ---- Parent tabs (desktop) ----
    var pNav = root.querySelector('.trk-tabs__nav');
    if (pNav) {
      var pTabs = pNav.querySelectorAll('.trk-tabs__tab');
      var pPanels = root.querySelectorAll(':scope > .trk-tabs__panels > .trk-tabs__panel');
      pTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.dataset.tab;
          pTabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          pPanels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === name); });
        });
      });
    }

    // ---- Parent accordions (mobile) ----
    root.querySelectorAll('.trk-tabs__acc').forEach(function (acc) {
      acc.addEventListener('click', function () {
        var panel = acc.closest('.trk-tabs__panel');
        if (panel) panel.classList.toggle('is-open');
      });
    });

    // ---- Child tabs (desktop), scoped to each subnav ----
    root.querySelectorAll('.trk-tabs__subnav').forEach(function (subnav) {
      var wrap = subnav.parentElement;
      var subTabs = subnav.querySelectorAll('.trk-subtab');
      var subPanels = wrap.querySelectorAll('.trk-subpanel');
      subTabs.forEach(function (st) {
        st.addEventListener('click', function () {
          var name = st.dataset.subtab;
          subTabs.forEach(function (t) { t.classList.toggle('is-active', t === st); });
          subPanels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.subpanel === name); });
        });
      });
    });

    // ---- Child accordions (mobile) ----
    root.querySelectorAll('.trk-subacc').forEach(function (acc) {
      acc.addEventListener('click', function () {
        var panel = acc.closest('.trk-subpanel');
        if (panel) panel.classList.toggle('is-open');
      });
    });

    // ---- Fill factory-option names + prices, tally total (GST-inc) ----
    var moneyAU = function (n) { return '$' + Math.round(n).toLocaleString('en-AU'); };
    root.querySelectorAll('.trk-fo__codes-list').forEach(function (list) {
      var total = 0, priced = 0;
      list.querySelectorAll('.trk-fo__code').forEach(function (btn) {
        var code = (btn.dataset.code || '').toUpperCase();
        var entry = descriptions[code] || descriptions[btn.dataset.code] || {};
        var titleEl = btn.querySelector('[data-code-title]');
        if (entry.title && titleEl) titleEl.textContent = entry.title;
        // Only top-level lines / package summaries carry the value chip (.trk-fo__code-incl);
        // package sub-items have none, so their value is never double-counted.
        var inclEl = btn.querySelector('.trk-fo__code-incl');
        if (inclEl && typeof entry.price === 'number' && entry.price > 0) {
          inclEl.textContent = moneyAU(entry.price);
          inclEl.classList.add('is-priced');
          total += entry.price; priced++;
        }
      });
      var foot = list.parentElement.querySelector('[data-fo-total]');
      if (foot && priced > 0) {
        foot.textContent = moneyAU(total) + ' inc. GST';
        foot.classList.add('is-priced');
      }
      // Surface the total on the "Upgraded Options" tab as a value signal vs Standard.
      var tabTotal = root.querySelector('[data-fo-total-tab]');
      if (tabTotal && priced > 0) tabTotal.textContent = ' + ' + moneyAU(total);
      // Expose the factory-upgrades total (AUD, inc GST) so the buybox price-breakdown can reuse it (single source).
      if (priced > 0) { window.trkFactoryTotal = total; document.dispatchEvent(new CustomEvent('trk:factory-total', { detail: total })); }
    });
  });
})();
